import { cssua as e } from "./cssuseragent.js";
//#region src/utils/deviceUtils.ts
document?.documentElement && e(document.documentElement, navigator.userAgent, navigator.standalone);
var t = (e) => e != null, n = () => {
	if (window.PointerEvent && t(navigator.maxTouchPoints)) {
		if (navigator.maxTouchPoints > 0) return !0;
	} else if (window.matchMedia?.("(any-pointer:coarse)").matches) return !0;
	else if (window.TouchEvent || t(window.ontouchstart)) return !0;
	return !1;
}, r = 480, i = 768, a = 992, o = 1200, s = 1700, c = () => window.matchMedia("(max-width: 480px)").matches, l = () => document?.documentElement.classList.contains("ua-mobile"), u = () => document?.documentElement.classList.contains("ua-desktop"), d = () => document?.documentElement.classList.contains("ua-desktop-macintosh"), f = () => window.devicePixelRatio > 1, p = () => {
	try {
		return window.self !== window.top;
	} catch {
		return !0;
	}
}, m = "user-scalable=0 maximum-scale=1", h = () => {
	if (!document) return;
	let e = document.head.querySelector("[name=\"viewport\"]");
	if (!e) return;
	let t = e.content.includes(m);
	if (l() && !t) {
		e.content += ` ${m}`;
		return;
	}
	if (!l() && t) {
		e.content = e.content.replace(m, "").trim();
		return;
	}
};
//#endregion
export { r as MOBILE_SCREEN, o as SCREEN_LG, a as SCREEN_MD, i as SCREEN_SM, s as SCREEN_XL, n as hasTouch, p as inIframe, u as isDesktop, d as isMac, l as isMobile, c as isMobileScreen, f as isRetinaDevice, h as toggleZoomOnMobile };

//# sourceMappingURL=deviceUtils.js.map